import { Injectable } from '@angular/core';

import {
  BaseWsService,
  ParsedWebsocketMessage,
  ResourcesService,
  ToastService,
  WebsocketMessageService,
} from '@mitsubishi/core';

import { QUOTE_TOPIC, QuoteMessages } from './quote.messages';

@Injectable({
  providedIn: 'root',
})
export class QuoteWsService extends BaseWsService {
  constructor(
    wsMessageService: WebsocketMessageService,
    serverResourceService: ResourcesService,
    toastService: ToastService
  ) {
    super(wsMessageService, serverResourceService, toastService);
  }

  setTopic(selectionId: string) {
    this.topic = `${QUOTE_TOPIC}/${selectionId}`;
  }

  handleMessage(message: ParsedWebsocketMessage) {
    super.handleMessage(message);

    const payload = message.payload;
    switch (message.description) {
      case QuoteMessages.LogMessage:
        this.logMessage(payload.message);
        break;
    }
  }
}
